(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.observer.disconnect();
        fetch(this.dataset.url).then((response) => {
          if (!response.ok) throw new Error('Recommendations unavailable');
          return response.text();
        }).then((text) => {
          const result = new DOMParser().parseFromString(text, 'text/html').querySelector('product-recommendations');
          if (result?.querySelector('.product-grid')) this.innerHTML = result.innerHTML;
        }).catch(() => {});
      }, { rootMargin: '400px' });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
